const oneTrust = {
  changeLocale(currentLocale: string) {
    if (this.isDefined()) {
      window?.OneTrust?.changeLanguage?.(currentLocale);
    }
  },
  
  showSettings() {
    if (this.isDefined()) {
      window?.OneTrust?.ToggleInfoDisplay?.();
    }
  },
  
  isDefined() {
    return typeof window !== 'undefined' && window.OneTrust;
  }
}

export default oneTrust;
